.root::before {
  content: "";
  position: fixed;
  visibility: hidden;
  opacity: 0;
  background-color: rgb(0 0 0 / 60%);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}

.root.open::before {
  visibility: visible;
  opacity: 1;
  transition: opacity 150ms ease;
  z-index: 99999;
}

.wrapper {
  position: fixed;
  bottom: 0; 
  left: 0;
  right: 0;
  /* z-index: 99; */
  z-index: 9;
  background-color: rgb(var(--color-gray-100));
  box-shadow: 0 -4px 32px 0 rgba(0 0 0 / 30%);
  max-height: 100vh;
  border-radius: 10px 10px 0 0;
  border-top-width: 1px;
} 
 
.wrapper.closed {
  /* background-color: rgb(var(--color-black)); */
  /* color: rgb(var(--color-white)); */
  /* border-color: rgb(var(--color-black)); */
  background-color: var(--bundle-bg); 
  color: var(--bundle-color);
  border-color: var(--bundle-bg);
}

.toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem 0;
}

.toggleLabel {
  text-align: left;
}

.toggleTitle {
  font-size: 1rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  font-weight: var(--font-heading-weight);
  font-family: var(--font-heading-family);
  font-feature-settings: var(--font-heading-settings);
  font-variant-numeric: lining-nums;
}

.toggleSubtitle {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.toggleIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.toggleIcon {
    width: 1rem;
    height: 1rem;
}

.toggle svg {
  transition: transform 150ms ease;
}

.root.open .toggle svg {
  transform: rotate(45deg);
}

.listWrapper {
  max-height: 0px;
  transition: max-height 300ms;
  overflow: hidden;
}

.list {
  list-style: none;
  padding-left: 0;
  margin: 0;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.product {
  display: flex;
  align-items: center;
}

.productImageWrapper {
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
}

.productImage {
  position: relative;
  width: 100%;
  display: block;
  padding-bottom: 100%;
  background-color: rgb(var(--color-render));
}

.productImage img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.productInfo {
  flex: 1;
}

.productTitle,
.productVariantPrice,
.productOption,
.productQuantity {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: rgb(var(--color-gray-900));
}

.productSubtitle {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgb(var(--color-gray-700));
}

.productPrice {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
}

.productButton {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nothing {
  display: flex;
  align-items: center;
}

.nothingImageWrapper {
  flex-grow: 0;
  flex-shrink: 0;
}

.nothingImage {
  width: 100%;
  display: block;
  padding-bottom: 100%;
  background-color: rgb(var(--color-render));
}

.nothingLabel {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgb(var(--color-gray-600));
}

.wrapper {
  transition: transform 300ms ease;
  transform: translateY(calc(100% - var(--toggle-height)));
}

.root.complete .wrapper {
  transform: translateY(0%);
}

.root.open .wrapper {
  transform: translateY(0%);
  z-index: 99999;
  overflow-y: auto;
}

.root.open .listWrapper {
  max-height: 100vh;
  transition: max-height 500ms;
}

.container {
  padding: 0 1rem;
}

.button {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.total {
  font-size: 1rem;
  line-height: 1.5rem;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -0.25rem;
  margin-left: -0.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.total > * {
  margin-top: 0.25rem;
  margin-left: 0.5rem;
}

.badge {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1rem;
  padding: 0.25rem 0.5rem;
  border-radius:100px;
  color: var(--color-sale-text);
  background-color: var(--color-sale);
  text-transform: uppercase;
}
.itemSavingsBadge{
  font-weight: 700;
  color: var(--color-sale-text);
  background-color: var(--color-sale);
  text-transform: uppercase;
  font-size: 0.6rem;
  padding: 0.1rem 0.375rem;
  line-height: 1rem;
  border-radius:100px;
}

.topButton {
  position: absolute;
  bottom: calc(100% + 1rem);
  right: 1rem;
}

@media (max-width: 767px) {
  .listItem + .listItem {
    margin-top: 0.5rem;
  }

  .productImageWrapper,
  .nothingImageWrapper {
    width: 64px;
    margin-right: 1rem;
  }

  .productInfo {
    min-width: 0;
  }

  .productTitle,
  .productSubtitle {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (min-width: 768px) {
  .container {
    padding: 0 3rem;
    max-width: 1024px;
    margin: 0 auto;
  }

  .button {
    padding: 1rem 0;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .listItem {
    /* flex: 1; */
    width: 100%;
    max-width: calc(25% - 3 * 1rem / 4);
  }

  /* .listItem + .listItem {
    margin-left: 1rem;
  } */

  .product,
  .nothing {
    flex-direction: column;
    align-items: flex-start;
  }

  .product {
    position: relative;
  }

  .productButton {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background-color: rgb(var(--color-white));
    padding: 0.5rem;
    border-radius: 1rem;
    box-shadow: 0 0 12px 0 rgba(0 0 0 / 15%);
  }

  .productButton::after {
    content: "";
    position: absolute;
    left: -0.5rem;
    right: -0.5rem;
    top: -0.5rem;
    bottom: -0.5rem;
  }

  .productButton svg {
    width: 1rem;
    height: 1rem;
  }

  .productImageWrapper,
  .nothingImageWrapper {
    width: 100%;
    margin-bottom: 1rem;
  }

  .topButton {
    right: calc((100% - min(1024px, 100vw)) / 2 + 3rem);
  }
}

.button.loading{
  background-color: rgb(var(--color-green));
}